import { createAsyncThunk } from '@reduxjs/toolkit'
import logout from 'api/user/logout'
import type { RootState } from 'state/store'
import { getSessionKey, removeSessionKey } from 'storage/sessionKey'

import { logoutRealtimeEventsClient } from '../../../realtime/BrowserRealtimeEventsClient'
import { broadcastAuthLogout } from '../authChannel'
import endUserSession from './endUserSession'

interface LogoutUserConfig {
    skipLogoutLegacyApp?: boolean
    skipRedirect?: boolean
}

const logoutUser = createAsyncThunk(
    'user/logout',
    async (params: LogoutUserConfig | undefined, { dispatch, getState }) => {
        const keyAtDispatchTime = getSessionKey()

        logoutRealtimeEventsClient()
        dispatch(endUserSession())
        broadcastAuthLogout()

        if (!params?.skipLogoutLegacyApp) {
            window.authenticatorIFrameClient?.logout()
        }

        await logout()

        // A completed logout must not clear or redirect a newer login.
        if (
            getSessionKey() !== keyAtDispatchTime ||
            (getState() as RootState).user.isLoggedIn
        ) {
            return
        }

        removeSessionKey()

        if (!params?.skipRedirect) window.location.hash = '#/'
    },
)

export default logoutUser
